import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";
import { sortAlphanum } from "../alphanumericSort";
import store from "@/store";
/* eslint-disable */
const state = {};

const getters = {};

const actions = {
  async getUsers({ commit }, broker) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "brokers/" + broker + "/users";
    return ApiService.get(url);
  },

  getUser({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      options.broker +
      "/users/" +
      options.user +
      "?$expand=Employers($expand=Translations($select=Name,Id);$select=UniqueIdentifier,Id),Stores($expand=Translations($select=Name,Id);$select=Id),Broker($select=Name,Id),Plans($select=Name,Id,UniqueIdentifier;$expand=Translations($select=Name,LanguageCode),Tags($select=Name,Id;$expand=Plans($select=Id)))&$select=Id,UserName,FirstName,LastName,Email,RegistrationDate,LastLoginDate,LoginStatus,Roles,IsConfirmed,IsActive";
    return ApiService.get(url);
  },
  getUserByEmail({ commit }, options) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "users/getByEmail/" + options.email;
    return ApiService.get(url);
  },
  getOrganizations() {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "brokers?$filter=IsActive eq true";
    return ApiService.get(url);
  },

  updateOrganization({ state }, broker) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "brokers/" + broker.Id;
    return ApiService.put(url, broker);
  },
  getTags({ state }, broker) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      broker +
      "/tags?$expand=Plans&$orderby=Name";
    return ApiService.get(url);
  },
  getTag({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      options.broker +
      "/tags/" +
      options.id +
      "?$expand=Plans($select=Name,Id,UniqueIdentifier),Broker($select=Name,Id)&$select=Id,Name,Description";
    return ApiService.get(url);
  },

  async getOrganizationPlans({ commit }, brokerId) {
    try {
      const language = store.getters["common/language"];
      console.log(language);
      var settings = SettingsService.settings;
      const url =
        settings.APIURL +
        "brokers/" +
        brokerId +
        //TODO: EXPAND EMPLOYERS STORES
        "/assignable-plans?$expand=Translations,Employers($select=Id,UniqueIdentifier,PlanId;$expand=Translations),Stores($select=Id,Number,PlanId;$expand=Translations),Tags($select=Name,Id;$expand=Plans($select=Id))&$orderby=Name";
      let data = (await ApiService.get(url)).data.value.sort((a, b) => {
        const translatedA = a.Translations.filter(
          (o) => o.LanguageCode === language.language,
        )[0].Name;
        const translatedB = b.Translations.filter(
          (o) => o.LanguageCode === language.language,
        )[0].Name;
        console.log(translatedA, translatedB);
        return sortAlphanum(translatedA, translatedB);
      });
      return {
        data: {
          value: data,
        },
      };
    } catch (error) {
      throw error;
    }
  },

  updateUser({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      options.broker +
      "/users/" +
      options.user.Id;
    return ApiService.put(url, options.user);
  },

  newUser({ state }, options) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "brokers/" + options.broker + "/users";
    return ApiService.post(url, options.user);
  },

  registerWithToken({ state }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      options.broker +
      "/users/registerWithToken";
    return ApiService.post(url, options.payload);
  },

  resetPassword({ state }, options) {
    var settings = SettingsService.settings;
    var url =
      settings.APIURL + "brokers/" + options.broker + "/users/resetPassword";
    return ApiService.post(url, options.payload);
  },

  resetPasswordWithToken({ state }, options) {
    var settings = SettingsService.settings;
    var url =
      settings.APIURL +
      "brokers/" +
      options.broker +
      "/users/resetPasswordWithToken";
    return ApiService.post(url, options.payload);
  },

  resetForgotPassword({ state }, options) {
    var settings = SettingsService.settings;
    var url = settings.APIURL + "users/resetPasswordByEmail";
    console.log(url, options.payload);
    return ApiService.post(url, options.payload);
  },
  forgotEmail({ state }, options) {
    var settings = SettingsService.settings;
    var url = settings.APIURL + "users/forgotEmail";
    return ApiService.post(url, options.payload);
  },
  setResetPassword({ state }, options) {
    var settings = SettingsService.settings;
    var url =
      settings.APIURL + "brokers/" + options.broker + "/users/setResetPassword";
    return ApiService.post(url, options.payload);
  },

  newTag({ state }, options) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "brokers/" + options.broker + "/tags";
    return ApiService.post(url, options.tag);
  },
  updateTag({ state }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + "brokers/" + options.broker + "/tags/" + options.tag.Id;
    return ApiService.put(url, options.tag);
  },
  deleteTag({ state }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + "brokers/" + options.broker + "/tags/" + options.tagId;
    return ApiService.delete(url);
  },
  updateUsersActive({ commit }, options) {
    var settings = SettingsService.settings;
    const url = settings.APIURL + "brokers/" + options.broker + "/users/status";
    return ApiService.post(url, options.payload);
  },
  updateUsersRoles({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + "brokers/" + options.broker + "/users/assign-roles";
    return ApiService.post(url, options.payload);
  },
  updateUsersPlans({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + "brokers/" + options.broker + "/users/assign-plans";
    return ApiService.post(url, options.payload);
  },
  updateUsersEmployersStores({ commit }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "brokers/" +
      options.broker +
      "/users/assign-employers-stores";
    return ApiService.post(url, options.payload);
  },
  deleteUser({ state }, options) {
    var settings = SettingsService.settings;
    const url =
      settings.APIURL + "brokers/" + options.broker + "/users/" + options.id;
    return ApiService.delete(url);
  },
};

const mutations = {};

export const applicationUsers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
